import Axios from 'api/client';

interface FetchReportColumnsParams {
    reportType:
        | 'transactions'
        | 'contacts'
        | 'companies'
        | 'recurring_payments'
        | 'pledges'
        | 'tickets'
        | 'auction_items';
}

interface ReportColumns {
    [key: string]: string;
}

const fetchReportColumns = (accountId: number, { reportType }: FetchReportColumnsParams) =>
    Axios.get<ReportColumns>(`/accounts/${accountId}/exports/${reportType}/fields`).then(
        response => response.data,
    );

export { fetchReportColumns };
export type { ReportColumns };
